import axios from 'axios';

const BASE_URL = '/api';

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem("user-token");
        if (token) {
            config.headers.common["Authorization"] = `JWT ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => {
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    }, error => {

        if (error.response) {
            // server responded with a status over 200
            console.warn('ERR-ReS: ', error.response);
        }
        else if (error.request) {
            // request was made but no response
            console.warn('ERR-ReQ: ', error.request);
        }
        else {
            console.warn('ERR-else: ', error.message);
        }

        return Promise.reject(error);
    }
);


/**
 * Base call used for each request.
 * @param {string} url
 * @param {string} method
 * @param {Object} data
 * @returns {AxiosPromise}
 */
const baseCall = (url, method, data = {}) => {
    return api({
        method: method,
        url: url,
        data: data
    });
};


const apiCall = {
    "login": (user) => baseCall('/api-token-auth/', 'POST', user),
    "logout": () => baseCall('/site_logout/', 'POST'),
    "refreshToken": (tokenObj) => baseCall('/api-token-refresh/', 'POST', tokenObj),
    "getUser": () => baseCall('/get-user/', 'GET'),
    "getPsInfo": () => baseCall('/get-dashboard-items/', 'GET'),
    "getDamInfo": (damName) => baseCall(`/get-dam-items/${damName}`, 'GET'),
    "getSensorChart": (data) => baseCall('/get-sensors-chart/', 'POST', data),
    "getCameraImages": (data) => baseCall('/get-camera-images/', 'POST', data),
    "getWeatherForecast": (data) => baseCall('/get-weather-forecast/', 'POST', data),
    "shootNewImage": (data) => baseCall('/shoot-new-image/', 'POST', data),
    "getCombinedChart": (data) => baseCall('/get-combined-chart/', 'POST', data),
    "getDamProfileImg": (damName) => baseCall(`/get-dam-profile-img/${damName}`, 'GET'),
    "getLogEntriesData": (data) => baseCall('/get-log-entries/', 'POST', data)
};

export default apiCall;